import styled from "styled-components";

export const Image = styled.img`
  /* margin: 15px; */
`;



// WEBPACK FOOTER //
// ./src/components/Logo/style.js